import type { DTO } from '@/type-utils';
import type IShippingMethod from '../IShippingMethod';
import MOCK_SHIPPING_METHODS from './MOCK_SHIPPING_METHODS';

// Use the STG (Standard Ground) shipping method from the mock array
const MOCK_SHIPPING_METHOD: DTO<IShippingMethod> = MOCK_SHIPPING_METHODS.find(
  (method) => method.id === 'STG'
)!;

export default MOCK_SHIPPING_METHOD;
